import { useIsDiscountGiftEnabled } from 'hooks/useIsDiscountGiftEnabled'
import { useDiscountDescriptor } from 'routes/Menu/components/BoxSummary/Banner/PriceAndDiscountTip/priceAndDiscountTipUtils'

import { formatDiscountTipWithDescription } from './discountAppliedBarUtils'

export const useDiscountAppliedData = () => {
  const discountDescriptor = useDiscountDescriptor()
  const isDiscountGiftingExperimentEnabled = useIsDiscountGiftEnabled()
  const { isDiscountEnabled } = discountDescriptor

  const discountAmount = formatDiscountTipWithDescription(discountDescriptor)

  const discountTip = isDiscountGiftingExperimentEnabled
    ? `${discountAmount} plus FREE DESSERT for three months`
    : discountAmount

  return {
    discountTip,
    isDiscountEnabled,
  }
}
